var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppointment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.255,
    height: 24.004,
    viewBox: "0 0 29.255 24.004",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2479",
    "data-name": "Group 2479",
    transform: "translate(-1820.7 -417.7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5496",
    "data-name": "Path 5496",
    d: "M1849.455,449v14.616a1.378,1.378,0,0,1-1.387,1.387h-25.482a1.378,1.378,0,0,1-1.387-1.387V449",
    transform: "translate(0 -23.799)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1925",
    "data-name": "Group 1925",
    transform: "translate(1825.951 418.2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1924",
    "data-name": "Group 1924",
    transform: "translate(0 2.591)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5497",
    "data-name": "Path 5497",
    d: "M1842.214,429.6a1.236,1.236,0,0,0-.114.5,1.318,1.318,0,1,0,2.637,0,1.236,1.236,0,0,0-.114-.5",
    transform: "translate(-1842.1 -429.6)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_1606",
    "data-name": "Line 1606",
    y1: 3.069,
    transform: "translate(1.318)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1927",
    "data-name": "Group 1927",
    transform: "translate(1842.09 418.2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1926",
    "data-name": "Group 1926",
    transform: "translate(0 2.591)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5498",
    "data-name": "Path 5498",
    d: "M1915.623,429.6a1.238,1.238,0,0,1,.114.5,1.318,1.318,0,0,1-2.637,0,1.238,1.238,0,0,1,.114-.5",
    transform: "translate(-1913.1 -429.6)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_1607",
    "data-name": "Line 1607",
    y1: 3.069,
    transform: "translate(1.318)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_1608",
    "data-name": "Line 1608",
    x1: 13.275,
    transform: "translate(1828.702 419.041)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5499",
    "data-name": "Path 5499",
    d: "M1825.892,421.9h-3.205a1.378,1.378,0,0,0-1.387,1.387v4.774h28.233v-4.774a1.378,1.378,0,0,0-1.387-1.387h-3.205",
    transform: "translate(-0.077 -2.859)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1928",
    "data-name": "Group 1928",
    transform: "translate(1829.224 428.225)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1609",
    "data-name": "Line 1609",
    y2: 2.887,
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1610",
    "data-name": "Line 1610",
    y2: 2.887,
    transform: "translate(4.069 0)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1611",
    "data-name": "Line 1611",
    y2: 2.887,
    transform: "translate(8.161 0)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1612",
    "data-name": "Line 1612",
    y2: 2.887,
    transform: "translate(12.23 0)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1613",
    "data-name": "Line 1613",
    y2: 2.887,
    transform: "translate(0 7.024)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1614",
    "data-name": "Line 1614",
    y2: 2.887,
    transform: "translate(4.069 7.024)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1615",
    "data-name": "Line 1615",
    y2: 2.887,
    transform: "translate(8.161 7.024)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1616",
    "data-name": "Line 1616",
    y2: 2.887,
    transform: "translate(12.23 7.024)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_1617",
    "data-name": "Line 1617",
    x2: 16.821,
    transform: "translate(1826.928 433.203)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5500",
    "data-name": "Path 5500",
    d: "M1849.563,432.3a2.14,2.14,0,0,1-4.273,0H1833.4a2.14,2.14,0,0,1-4.273,0H1826.4v2.637h25.869V432.3Z",
    transform: "translate(-4.018 -10.895)",
    fill: "#6c5b7b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointment);
export default __webpack_public_path__ + "static/media/Appointment.fe2066be7bb10a361ddc1ed21708bef0.svg";
export { ForwardRef as ReactComponent };